import type { ReviewRating, ReviewSummary } from './generated/graphql'
import { SubmitReviewDocument } from './generated/graphql'
import { createMutationHelper } from './utils'

export const [useSubmitReview, executeSubmitReview] =
  createMutationHelper(SubmitReviewDocument)

export async function submitModelItemReview(
  id: string,
  { rating }: { rating: ReviewRating },
) {
  const res = await executeSubmitReview(
    { input: { modelId: id, rating } },
    {
      onQueryUpdated: observableQuery => {
        // Refetch getGenerationModelDetail to update reviewSummary
        return observableQuery.refetch()
      },
      update: (cache, { data }, { variables }) => {
        const review = data?.review

        // Get the itemId from the review (or from variables if canceled)
        const itemId = review?.itemId || variables?.input.modelId
        if (!itemId) return

        // Update user's review on the GenerationModel
        cache.modify({
          id: cache.identify({
            __typename: 'GenerationModel' as const,
            id: itemId,
          }),
          fields: {
            myReview() {
              // Return the new review or null if canceled
              return review
            },
          },
        })
      },
    },
  )
  return res.data?.review
}

// ==================================================
// Utilities
// ==================================================

export function parseRatingDetail(data: ReviewSummary['ratingDetail']) {
  return Object.fromEntries(
    data.map(({ rating, count }) => [rating, count]),
  ) as Record<ReviewRating, number>
}
